module.exports = __webpack_public_path__ + "assets/4687061d950714580891d5e4c3b5083a.mp3";